import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { withTranslation } from 'react-i18next';
import i18n from '../assets/locales';

type Props = {};

type State = {
  redirect: string | null,
};

class RegisterSuccess extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

  }
  
  render() {
    return (
      <div style={{ padding: 20 }}>
        <h1>Registration Successful</h1>
        <p>
          Thank you for registering with SquareGolf! Your account has been successfully created. You can now sign in to your account and start exploring our services.
        </p>
        <p>
          If you have any questions or need assistance, please feel free to contact our support team at
          <a href='mailto:'>cs@invant.co</a>
        </p>
      </div>
    );
  }
}

export default withTranslation()(RegisterSuccess);
